/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorKeesingGames as ResolvedLabradorKeesingGames } from 'base/components/labrador/KeesingGames';

export const LabradorKeesingGames: typeof ResolvedLabradorKeesingGames = withLabradorInstanceof((props) => {
    return <ResolvedLabradorKeesingGames {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorKeesingGamesProps = PropsFromComponent<typeof LabradorKeesingGames>;
